import { combineReducers } from 'redux'

import apiReducer from "./api/apiReducer"
import registrationReducer from "./registration/registrationReducer"
import tabsReducer from "./tabs/tabsReducer"
import groupTabsReducer from "./tabs/groupTabsReducer"
import groupReducer from "./group/groupReducer"
import addMemberReducer from "./addMember/addMemberReducer"

export default combineReducers({
    apiReducer,
    registrationReducer,
    tabsReducer,
    groupTabsReducer,
    groupReducer,
    addMemberReducer
})
